import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_BASE } from '../lib/config';

const API = API_BASE;

const AdminSettingsPage = () => {
    const navigate = useNavigate();
    const [feeRate, setFeeRate] = useState(0.18);
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [message, setMessage] = useState('');

    // Fetch current setting
    useEffect(() => {
        const fetchSettings = async () => {
            try {
                const token = localStorage.getItem('token');
                const res = await fetch(`${API}/admin/settings/fee`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                if (res.ok) {
                    const data = await res.json();
                    setFeeRate(data.platform_fee_rate);
                }
            } catch (err) {
                console.error(err);
            } finally {
                setLoading(false);
            }
        };
        fetchSettings();
    }, []);

    const handleSave = async () => {
        setSaving(true);
        setMessage('');
        try {
            const token = localStorage.getItem('token');
            const res = await fetch(`${API}/admin/settings/fee`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({ platform_fee_rate: parseFloat(feeRate) })
            });

            if (res.ok) {
                setMessage('設定を保存しました。');
            } else {
                setMessage('保存に失敗しました。');
            }
        } catch (err) {
            console.error(err);
            setMessage('エラーが発生しました。');
        } finally {
            setSaving(false);
        }
    };

    if (loading) return <div className="p-8">Loading...</div>;

    return (
        <div className="min-h-screen bg-gray-50 flex">
            {/* Sidebar (Simplified) */}
            <div className="w-64 bg-white border-r border-gray-200 hidden md:block">
                <div className="p-6 border-b border-gray-100">
                    <h1 className="text-xl font-bold text-gray-800">管理画面</h1>
                </div>
                <nav className="p-4 space-y-2">
                    <button onClick={() => navigate('/admin')} className="w-full text-left px-4 py-2 hover:bg-gray-50 rounded">ダッシュボード</button>
                    <button onClick={() => navigate('/admin/users')} className="w-full text-left px-4 py-2 hover:bg-gray-50 rounded">ユーザー管理</button>
                    <div className="px-4 py-2 bg-blue-50 text-blue-600 rounded font-bold">システム設定</div>
                </nav>
            </div>

            <div className="flex-1 p-8">
                <div className="max-w-4xl mx-auto">
                    <header className="mb-8 flex justify-between items-center">
                        <h1 className="text-2xl font-bold text-gray-800">システム設定</h1>
                        <button onClick={() => navigate('/admin')} className="text-gray-500 hover:text-gray-700">戻る</button>
                    </header>

                    <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
                        <h2 className="text-lg font-bold mb-4">手数料設定</h2>

                        <div className="mb-6">
                            <label className="block text-sm font-medium text-gray-700 mb-2">プラットフォーム手数料率 (1.0 = 100%)</label>
                            <p className="text-sm text-gray-500 mb-4">
                                求職者支払い額に対して、事業者が支払う追加手数料の割合です。<br />
                                例: 0.18 = 18% (求職者10,000円の場合、事業者支払額は11,800円)
                            </p>

                            <div className="flex items-center gap-4">
                                <input
                                    type="number"
                                    value={feeRate}
                                    onChange={(e) => setFeeRate(e.target.value)}
                                    step="0.01"
                                    min="0"
                                    max="1"
                                    className="w-32 px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
                                />
                                <span className="text-gray-600 font-bold text-lg">
                                    = {(feeRate * 100).toFixed(1)}%
                                </span>
                            </div>
                        </div>

                        {message && (
                            <div className={`p-4 rounded-lg mb-4 ${message.includes('失敗') ? 'bg-red-50 text-red-600' : 'bg-green-50 text-green-600'}`}>
                                {message}
                            </div>
                        )}

                        <button
                            onClick={handleSave}
                            disabled={saving}
                            className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition-colors disabled:opacity-50"
                        >
                            {saving ? '保存中...' : '設定を保存'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminSettingsPage;
